import { render, staticRenderFns } from "./PersonalProfile.vue?vue&type=template&id=45bee56b&scoped=true"
import script from "./PersonalProfile.vue?vue&type=script&lang=js"
export * from "./PersonalProfile.vue?vue&type=script&lang=js"
import style0 from "./PersonalProfile.vue?vue&type=style&index=0&id=45bee56b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bee56b",
  null
  
)

export default component.exports